export default "__VITE_ASSET__DFuJq0jk__"